import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Job, JobList } from '../model/job.model';
import { JobDocument, JobDocumentList } from '../model/jobDocument';

@Injectable({
    providedIn: 'root'
})
export class JobService extends KiwixiService {
    apiJobsUrl = environment.server + 'jobs/';

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    get(params: any): Observable<JobList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.get<JobList>(this.apiJobsUrl, {
            params: params,
            headers: header
        });
    }

    getOne(id: any, salt = false): Observable<Job> {
        const header = this.createHttpClientAuthorizationHeader();
        let url = this.apiJobsUrl + id + '/';
        if (salt)
            url += '?salt=' + Math.random();
        return this._httpClient.get<Job>(url, {
            headers: header
        });
    }

    post(data): Observable<Job> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.post<Job>(this.apiJobsUrl, data, { headers: header });
    }

    patch(data, id): Observable<Job> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.patch<Job>(this.apiJobsUrl + id + '/', data, { headers: header });
    }

    getElasticSearch(params: any): Observable<JobDocumentList> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<JobDocumentList>(environment.server + 'elastic_search/jobs/', {
            params: params,
            headers: header
        });
    }

    getElasticSearchSuggest(params: any): Observable<any> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<any>(environment.server + 'elastic_search/jobs_suggest/', {
            params: params,
            headers: header
        });
    }

    getElasticSearchExactAutreJob(params?: any): Observable<JobDocument> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<JobDocument>(environment.server + 'elastic_search/exact_autre_job/', {
            params: params,
            headers: header
        });
    }

    getJobSituations() {
        return [
            {
                value: 'student',
                label: 'jobSituation.student.label',
            },
            {
                value: 'unemployed',
                label: 'jobSituation.unemployed.label',
            },
            {
                value: 'employed',
                label: 'jobSituation.employed.label',
            },
            {
                value: 'retired',
                label: 'jobSituation.retired.label',
            },
        ];
    }
    
}
